// Toggle a <meta name="robots"> tag on the document head (#526).
//
// The router's afterEach hook calls this on every navigation, reading
// `to.meta.noindex`. Private routes (admin, portal, magic-link
// landings, etc.) get the tag injected with content="noindex,nofollow";
// public routes have it removed so search engines treat them as
// indexable.
//
// JS-disabled crawlers won't see this tag — that's what robots.txt
// (served by functions/robots.txt.ts) covers. The two together are
// belt-and-braces: robots.txt saves crawl budget for the bots that
// honour it, the meta tag is the hard "do not index" signal for the
// JS-rendered SPA paths that pass the robots.txt allowlist.
//
// Exported separately from router/index.ts so vitest can exercise the
// DOM-mutation logic without spinning up the full router. Keep this
// module side-effect-free: no top-level mutation, no imports of router
// types.

const ROBOTS_NAME = 'robots'
const NOINDEX_CONTENT = 'noindex,nofollow'

export function applyRobotsMeta(noindex: boolean, doc: Document = document): void {
  const existing = doc.head.querySelector(`meta[name="${ROBOTS_NAME}"]`)
  if (noindex) {
    if (existing) {
      existing.setAttribute('content', NOINDEX_CONTENT)
    } else {
      const meta = doc.createElement('meta')
      meta.setAttribute('name', ROBOTS_NAME)
      meta.setAttribute('content', NOINDEX_CONTENT)
      doc.head.appendChild(meta)
    }
  } else if (existing) {
    existing.remove()
  }
}
